export const PICKUP = 'PICKUP';
export const SHIPPING = 'SHIPPING';
